(() => {
  const TAG = 'omega3-sticky-bar';
  if (customElements.get(TAG)) return;

  class Omega3StickyBar extends HTMLElement {
    constructor() {
      super();
      this.onScroll = this.onScroll.bind(this);
      this.evaluate = this.evaluate.bind(this);
      this.ticking = false;
    }

    connectedCallback() {
      this.findTargets();

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(this.evaluate, { threshold: [0, 0.01] });
        if (this.hero) this.observer.observe(this.hero);
        if (this.footer) this.observer.observe(this.footer);
      }

      this.evaluate();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      document.removeEventListener('scroll', this.onScroll, { capture: true });
      this.observer?.disconnect();
    }

    findTargets() {
      this.hero = document.querySelector(
        this.dataset.showAfter === 'inline_bar' ? '[data-omega3-sticky-inline]' : '[data-omega3-hero]'
      );
      this.footer = document.querySelector('[data-omega3-footer]');
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.evaluate();
        this.ticking = false;
      });
    }

    evaluate() {
      if (!this.hero || !this.footer) this.findTargets();

      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      let pastHero = true;
      if (this.hero) {
        const rect = this.hero.getBoundingClientRect();
        // reveal once ~60% of the hero has scrolled above the top of the viewport
        pastHero = rect.bottom <= rect.height * 0.4;
      }

      const nearFooter = this.footer ? this.footer.getBoundingClientRect().top <= viewportHeight : false;

      this.classList.toggle('is-visible', pastHero && !nearFooter);
    }
  }

  customElements.define(TAG, Omega3StickyBar);
})();
